<template>
  <el-card>
    <el-tabs tab-position='left' v-model="active" @tab-click='handleTabClick'>
      <el-tab-pane name='kitchen'>
        <span slot="label" class="item"> 厨电类</span>
        <Kitchen ref='kitchen'/>
      </el-tab-pane>
      <el-tab-pane name='air' :lazy='true'>
        <span slot="label" class="item"> 空气类</span>
        <AirCleanerModel ref='air'/>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import Kitchen  from './module.vue'
import AirCleanerModel  from './AirCleanerModel.vue'
export default {
  components: {
    Kitchen,
    AirCleanerModel,
  },
  data() {
    return {
      active: "kitchen"
    }
  },
  methods: {
    handleTabClick(tab) {
    console.log(tab)
      this.$nextTick(() => {
        this.$refs[tab.name] && this.$refs[tab.name].getList()
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .item {
    display: block;
    width: 100px;
    text-align: right;
    font-size: 16px;
  }
</style>